import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-view-config-presorteo',
  templateUrl: './page-view-config-presorteo.component.html',
  styleUrls: ['./page-view-config-presorteo.component.scss']
})
export class PageViewConfigPresorteoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
